const CONSOLIDACAO_TIPO = {
    IND: { id: 0, descricao: 'Individual' },
    CNS: { id: 1, descricao: 'Consolidado' },
    CNSPRD: { id: 3, descricao: 'Consolidado Prudencial' },
    CNSFNC: { id: 5, descricao: 'Consolidado Financeiro' }
};

module.exports = CONSOLIDACAO_TIPO;
